/**
 * Pleae remember to change the olors in src/semantic/src/site/globals/site.variables
 * /README.md for moredetails
 **/
// grey colors variations
// to keep consistent, please keep only one grey per R family (rgb)
const shades = {
  1: '#111111',
  2: '#2e2e2e',
  3: '#3f3f3f',
  4: '#4f4f4f',
  5: '#5f5f5f',
  6: '#626262',
  7: '#7c7c7c',
  8: '#8b8b8b',
  9: '#9b9b9b',
  a: '#a4a4a4',
  d: '#dbdbdb',
  e: '#ededed',
  f: '#fafafa'
};

const base = {
  // Site Colors
  //*---  Colors  ---*/
  red: '#BA0000',
  orange: '#f16321',
  green: '#01763c',
  blue: '#266ABD',
  teal: '#56cae7',
  yellow: '#FFE35E',

  //*---  Greyscale Colors (dark to light)  ---*/
  ...shades,
  black: shades['1'],
  darkBlack: shades['2'],
  lighterBlack: shades['4'],
  lightBlack: shades['6'],
  darkGrey: shades['7'],
  grey: shades['9'],
  lightGrey: shades.a,
  borderGrey: shades.d,
  lighterGrey: shades.e,
  greyBackground: shades.f,
  white: '#fff',

  //*---  Light Colors  ---*/
  lightRed: '#FF695E',
  lightOrange: '#FF851B',
  lightYellow: '#FFE21F',
  lightOlive: '#D9E778',
  lightGreen: '#02a352',
  lighterGreen: '#006F44',
  lightTeal: '#6DFFFF',
  lightBlue: '#54C8FF',
  lightViolet: '#A291FB',
  lightPurple: '#DC73FF',
  lightPink: '#FF8EDF',
  lightBrown: '#D67C1C',

  //*--- Colored Backgrounds ---*/
  redBackground: '#FAe9e7',
  orangeBackground: '#FFE7C6',
  yellowBackground: '#fdf3e6',
  greenBackground: '#e9f0ec',
  tealBackground: '#edf9fc',
  oliveBackground: '#FBFDEF',
  blueBackground: '#e9f0f8',
  violetBackground: '#EAE7FF',
  purpleBackground: '#F6E7FF',
  pinkBackground: '#FFE3FB',
  brownBackground: '#F1E2D3'
};

const colors = {
  ...base,

  //*---   Neutrals  ---*/
  darkGreen: base.green,

  // Brand Colors
  primary: base.green,
  secondary: base.black,
  lightPrimary: base.lightGreen,
  lightSecondary: base.lightBlack,

  // Page
  textColor: base.black,
  linkColor: base.green
};

export default {
  ...colors,

  //* Positive */
  positive: colors.green,
  positiveBG: colors.greenBackground,

  //* Negative */
  negative: colors.red,
  negativeBG: colors.redBackground,

  //* Info */
  info: colors.teal,
  infoBG: colors.yellowBackground,

  //* Warning */
  warning: colors.orange,
  warningBG: colors.orangeBackground,

  notificationBackground: 'rgba(0,87,53,0.1)'
};



// WEBPACK FOOTER //
// ./src/styles/colors.js